import React, { Component } from 'react'
import Collector from '../Collector'
import classes from './Construction.css'
import bluePrintCollector from '../img/BluePrint.jpg'

class Construction extends Component {
    render() {
        return (
            <div >
                <Collector />
                <div className={classes.Construction}>
                    <div className="container">
                        <div className='row'>
                            <div className='col-7'>
                                <h2>Схема конструкции:</h2>
                                <img className={classes.bluePrintImg} src={bluePrintCollector} alt=''></img>
                            </div>
                            <div className='col-5'>

                                <div className={classes.descriptionConstruction}>
                                    <h2>Пояснение к схеме:</h2>
                                    <p className={classes.descriptionP}> 1 - зеркальный концентратор (упакованный)</p>
                                    <p className={classes.descriptionP}> 2 - лепестки ФЭП (в сложенном виде)</p>
                                    <p className={classes.descriptionP}> 3 - телескопическая опора</p>
                                    <p className={classes.descriptionP}> 4 – датчик контроля давления во всех полостях</p>
                                    <p className={classes.descriptionP}> 5 - радиальные нитевидные растяжки</p>
                                    <p className={classes.descriptionP}> 6 - верхняя часть зеркального концентратора</p>
                                    <p className={classes.descriptionP}> 7 - нижняя часть зеркального концентратора</p>
                                    <p className={classes.descriptionP}> 8 - термомеханические защитные элементы</p>
                                    <p className={classes.descriptionP}> 9 - механизмы регулирования натяжения растяжек</p>
                                    <p className={classes.descriptionP}> 10 – устройство отвода электрического тока и тепла от лепестков ФЭП по отдельным каналам</p>
                                    <p className={classes.descriptionP}> 11 - система космических технологических модулей</p>
                                    <p className={classes.descriptionP}> 12 - солнечный фотоэлектрический модуль</p>
                                    <p className={classes.descriptionP}> 13 – модуль преобразования электрического тока в СВЧ или лазерный поток энергии и дистанционной передачи энергии потребителю
</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={classes.Patentinfo}>
                        <h1>
                            СОЛНЕЧНЫЙ ФОТОЭЛЕКТРИЧЕСКИЙ МОДУЛЬ (патент №2717695) позволяет уменьшить вес спутника, без потери его функциональности за счёт уменьшения массы солнечных батарей,
                            без уменьшения их энергоёмкости.
                    </h1>
                    </div>
                </div>
            </div>

        )
    }
}
export default Construction


// WEBPACK FOOTER //
// ./src/containers/Collector/Collector Constaruction/Constaruction.js